@reference "@glow/tailwind-config/reference.css";

.tabList {
  @apply flex;
  @apply flex-wrap;
  @apply gap-4;
  @apply mt-4;
  @apply mb-6;
}

.tabList li {
  @apply list-none;
}

.tabList a,
.tabList button {
  @apply text-sm;
  @apply cursor-pointer;
  @apply text-emphasis-medium;
  @apply py-2;
  @apply px-4;
  @apply rounded-sm;
}

.tabList a:hover,
.tabList button:hover {
  @apply bg-gray-100;
  @apply shadow-gray-500;
}

.tabList a[data-selected="true"],
.tabList a[aria-current="page"],
.tabList button[data-selected="true"],
.tabList button[aria-current="page"] {
  @apply border-primary-500;
  @apply text-primary-500;
  @apply bg-primary-100;
  @apply border;
  @apply border-solid;
  @apply font-semibold;
  @apply hover:shadow-hover-selected;
}

.tabList svg {
  @apply text-base;
}
